import { MissionData } from '../blocks/mission'
import template from './templates/RJF04.rbxl'
import thumbnail1 from './thumbnails/RJF04/BrownBlock.png'
import thumbnail2 from './thumbnails/RJF04/WhiteBlock.png'
import thumbnail3 from './thumbnails/RJF04/PinkBlock.png'

const mission: MissionData = {
  // Set the template and other metadata.
  // テンプレートとその他のメタデータを設定します。
  number: 2,
  stage: 0,
  thumbnail: '',
  title: '',
  template,
  chapters: [{}, {}, {}, {}, {}],
  objects: [
    {
      name: '①ちゃいろのブロック',
      thumbnail: thumbnail1,
    },
    {
      name: '②しろいブロック',
      thumbnail: thumbnail2,
    },
    {
      name: '③ピンクのブロック',
      thumbnail: thumbnail3,
    },
  ],
}

export default mission
